import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

// Provides standard horizontal padding for the content that lives inside a grid cell.
export const ContentBlock = ({ children }: PropsWithChildren) => (
  <Flex flexDirection="column" paddingY="0.5rem">
    {children}
  </Flex>
);
